export const SCREEN_SIZES = {
	MOBILE: 768,
	TABLET: 1024,
	DESKTOP: 1440,
	LARGE_DESKTOP: 1920,
};

export const DEFAULT_SPEECH_LOCALE = 'nl';
